import styled from '@emotion/styled'

export const RoutesMain = styled.main`
  flex: auto;
  min-height: 500px;
`
